export default __webpack_public_path__ + "static/media/slide18.815f626d.jpg";